import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { AffiliationBlockType } from '@uno/common-cms';
import { BorderGradientButton } from 'components/common/material-ui/custom-components/BorderGradientButton.style';
import { Bullet, Pen, Slideshow } from 'theme/icons';
import { ButtonsContainer } from './AffiliationBlockTypeSelection.style';

var getTypeIcon = function getTypeIcon(type) {
  switch (type) {
    case AffiliationBlockType.Cta:
      return __jsx(Pen, null);

    case AffiliationBlockType.PriceTable:
      return __jsx(Bullet, null);

    case AffiliationBlockType.Slideshow:
      return __jsx(Slideshow, null);

    default:
      return __jsx(React.Fragment, null);
  }
};

var getTypeLabel = function getTypeLabel(type) {
  return type.toLowerCase().replace('_', '-');
};

var AffiliationBlockTypeSelection = function AffiliationBlockTypeSelection(_ref) {
  var selectedType = _ref.selectedType,
      _onClick = _ref.onClick;
  return __jsx(ButtonsContainer, null, Object.values(AffiliationBlockType).map(function (affiliationBlockType) {
    return __jsx(BorderGradientButton, {
      key: affiliationBlockType,
      onClick: function onClick() {
        return _onClick(affiliationBlockType);
      },
      startIcon: getTypeIcon(affiliationBlockType),
      selected: affiliationBlockType === selectedType,
      centered: true
    }, __jsx(FormattedMessage, {
      id: "affiliation-block-modal.types.".concat(getTypeLabel(affiliationBlockType))
    }));
  }));
};

export default AffiliationBlockTypeSelection;